import { Injectable } from '@angular/core';
import { Constants } from '../helper/constants';

@Injectable()
export class HelperService {

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
return false;
}
    }
    return true;
  }

}
